module.exports = __webpack_public_path__ + "img/arrow-right.0e94c977.svg";